var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54939 19.8187C9.03726 19.8187 9.43276 19.4232 9.43276 18.9354C9.43276 18.4475 9.03726 18.052 8.54939 18.052C8.06151 18.052 7.66602 18.4475 7.66602 18.9354C7.66602 19.4232 8.06151 19.8187 8.54939 19.8187Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2667 19.8187C18.7545 19.8187 19.15 19.4232 19.15 18.9354C19.15 18.4475 18.7545 18.052 18.2667 18.052C17.7788 18.052 17.3833 18.4475 17.3833 18.9354C17.3833 19.4232 17.7788 19.8187 18.2667 19.8187Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48242 1.26807H5.0159L7.38334 13.0964C7.46412 13.5031 7.68537 13.8684 8.00836 14.1284C8.33136 14.3884 8.73551 14.5266 9.15008 14.5186H17.7364C18.151 14.5266 18.5552 14.3884 18.8782 14.1284C19.2012 13.8684 19.4224 13.5031 19.5032 13.0964L20.9166 5.68492H5.89927",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartImage);
export default __webpack_public_path__ + "static/media/cart-image.d0412ca072fcb9076da303be38c0b126.svg";
export { ForwardRef as ReactComponent };